import useLocationSearch from "./useLocationSearch";

export default function useQueryParam(param) {
  const searchString = useLocationSearch();
  const params = new URLSearchParams(searchString);
  return params ? params.get(param) : "";
}
